import 'lib-flexible';
import '@/styles/common.scss';

import { createApp } from 'vue';
// import { createPinia } from 'pinia';
import { setupStore } from '@/stores';
import App from './App.vue';
import router from './router';
// Toast
import 'vant/es/toast/style';
// Dialog
import 'vant/es/dialog/style';
// Notify
import 'vant/es/notify/style';
// ImagePreview
import 'vant/es/image-preview/style';
// import '@/utils/jmlink';
import baiduAnalytics from 'vue-baidu-analytics';
import { initAMapApiLoader } from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css';
import { setupEventTrack } from '@/utils/event-track';
import VueVideoPlayer from '@videojs-player/vue';
import 'video.js/dist/video-js.css';
import ccworkBridge from 'ccwork-jsbridge';
import { Lazyload } from 'vant';
// import VConsole from 'vconsole';

// new VConsole();

initAMapApiLoader({
  key: '584e92a9c12c0b27cb849ae722e5d1e6',
});

console.log('ccworkBridge', ccworkBridge);
ccworkBridge.init(function () {
  console.log('0-ccwork初始化');
  const app = createApp(App);

  // app.use(createPinia());
  app.use(router);
  setupStore(app);

  app.use(baiduAnalytics, {
    router: router,
    siteIdList: ['680c610853e9c97b010ddcef12f3d1c1'],
    isDebug: false,
  });
  app.use(Lazyload, {
    preLoad: 1.2, // 预加载比例
  });
  app.use(VueVideoPlayer);
  setupEventTrack(app);
  app.mount('#app');
});
